<template>
    <b-modal :title="title" ref="mdlSignPrintComponent" size="xl" style="height: 100%" scrollable @shown="onShown"
        dialog-class="sa-modal-full-height">
        <div style="height: 100%; background-color: transparent; overflow: hidden">
            <div style="background-color: transparent; height: 50%">
                <slot name="body-component"></slot>
            </div>
            <div>
                <!-- <b-embed type="iframe" ref="pdfNotSignedEmbeddedComponent" :src="pdf" allowfullscreen></b-embed> -->
                <div v-if="pdf"><b-embed type="iframe" ref="pdfNotSignedEmbeddedComponent" :src="pdf"
                        allowfullscreen></b-embed></div>
                <div v-else class="sa-badge-container-center">
                    <div class="sa-badge-large">Pdf non ancora disponibile, selezionare un elemento</div>
                </div>
            </div>
        </div>

        <!-- <vue-pdf-embed ref="pdfNotSignedEmbeddedComponent" :source="stampaReport"></vue-pdf-embed> -->
        <template #modal-footer>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Dispositivo:</label>
                    <!-- <b-form-select v-model="dispositivo" :options="dispositiviOption" value-field="value" text-field="text"></b-form-select> -->
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-form-select :disabled="isDisableSign" v-model="dispositivo" :options="dispositiviOptions"
                        value-field="value" text-field="text"></b-form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-button :disabled="isDisableSign" size="sm" variant="outline-secondary"
                        @click="onFirmaGrafometrica()">
                        <b-icon icon="pencil-square"></b-icon>
                        Firma Grafometrica
                    </b-button>
                    <b-button :disabled="isDisableSign" size="sm" variant="outline-secondary"
                        @click="onPrintNotSigned()">
                        <b-icon icon="printer"></b-icon>
                        Stampa
                    </b-button>
                    <b-button :disabled="pdf === null" size="sm" variant="outline-success"
                        @click="onClickConferma()">Conferma</b-button>
                    <b-button size="sm" variant="danger" @click="onClickClose()">Chiudi</b-button>
                </b-col>
            </b-row>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
    data() {
        return {
            title: "",
            pdf: null,
            dispositivo: "",
            dispositiviOptions: [{ value: "", text: "-Seleziona Dispositivo-" }],
            pathResourceDispositivi: "/digitalsigndevice",
            pathDigitalSign: "/sign/internal",
            consensoFirmato: {},
            isDisableSign: true,
        };
    },
    mounted() {
        // console.log("Munted");
        this.loadDevice();
    },
    methods: {
        show() {
            this.$refs.mdlSignPrintComponent.show();
        },
        hide() {
            this.consenso = {};
            this.pdf = null;
            this.$refs.mdlSignPrintComponent.hide();
        },
        init() {
            this.pdf = null;
            this.consensoFirmato = {};
            this.$refs.mdlSignPrintComponent.show();
        },
        loadDevice() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDispositivi;
            let filtro = { tipoFirma: "GRAFOMETRICA", gestore: "KEFIRMA" };
            me.dispositiviOptions = [];
            axios
                .get(link, { params: filtro })
                .then((response) => {
                    response.data.data.list.forEach((element) => {
                        me.dispositiviOptions.push({ value: element.codiceDispositivo, text: element.descrizioneDispositivo + " (" + element.codiceDispositivo + ")" });
                    });
                    me.dispositiviOptions.unshift({ value: "", text: "-Seleziona Dispositivo-" });
                })
                .catch(() => {
                    // console.log(e);
                    //   this.errors.push(e);
                });
        },
        onShown() {
            if (this.pdf === null) {
                this.isDisableSign = true;
                this.pdf = null;
                this.title = "---";
                this.$emit("onshown");
            }
        },
        setData(title, pdf) {
            this.title = title;
            this.pdf = pdf;
            // console.log(pdf);
        },
        setDataForSign(consenso) {
            let me = this;
            // console.log(consenso);

            // me.consensoFirmato = { id: consenso.idRisorsa, nomeConsenso: consenso.tipoDocumento };
            me.consensoFirmato = { id: consenso.idRisorsa, nomeConsenso: consenso.tipoDocumento };
            this.isDisableSign = false;
            me.title = consenso.tipoDocumento;
            this.pdf = consenso.base64.includes("data:application/pdf;base64,") ? consenso.base64 : "data:application/pdf;base64," + consenso.base64;
            me.$refs.mdlSignPrintComponent.show();
        },
        onClickClose() {
            let me = this;
            me.mdlStampaFirmaGrafometricaClose();
        },
        mdlStampaFirmaGrafometricaClose() {
            let me = this;
            me.$refs.mdlSignPrintComponent.hide();
        },
        onFirmaGrafometrica() {
            let me = this;
            // let file = this.pdf.includes("data:application/pdf;base64,") ? this.pdf : "data:application/pdf;base64," + this.pdf; //this.pdf.includes("data:application/pdf;base64,") ? this.pdf : "data:application/pdf;base64," +
            let file = this.pdf.replace("data:application/pdf;base64,", "");
            console.log(me.consensoFirmato);

            // console.log(file);

            let signBean = {
                tipo: "GRAFOMETRICA",
                codiceDispositivo: me.dispositivo,
                codiceApplicativo: "PAZIENTICONSENSI",
                files: [{ idRiferimento: me.consensoFirmato.id, filename: me.consensoFirmato.nomeConsenso + moment(new Date()).format("YYYY_MM_DD_HHmmss") + ".pdf", fileBase64: file }],
            };
            me.digilatSignRequest(signBean);
        },
        onPrintNotSigned() { },
        onClickConferma() {
            this.isDisableSign = false;
            // console.log(this.pdf);

            this.$emit("confermaSelezione", this.pdf);
        },
        initConsenso(consensoFirmato) {
            let me = this;
            me.consensoFirmato = consensoFirmato;
        },
        digilatSignRequest(signBean) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathDigitalSign;
            // me.showModalLoading = true;
            // me.$refs.mdlInvioAlDispositivoInCorso.show();
            axios
                .post(link, signBean)
                .then((response) => {
                    // me.$refs.mdlInvioAlDispositivoInCorso.hide();
                    let message = response.data.messaggio;

                    this.$bvModal
                        .msgBoxOk(message, {
                            title: "Info",
                            size: "sm",
                            okVariant: "outline-success",
                            headerClass: "sa-msg-header-success",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {
                            me.$refs.mdlStampaFirmaGrafometrica.hide();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch((error) => {
                    me.$emit("closeModal");
                    let message = "";
                    error.response ? error.response.data.messaggio : "Errore non gestito";
                    if (error.response) {
                        message = error.response.data.messaggio ? error.response.data.messaggio : "Codice Errore: " + error.response.status + ", non gestito";
                    }
                    if (error.response) {
                        this.$bvModal
                            .msgBoxOk(message, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then(() => { })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                });
        },
    },
};
</script>

<style></style>
